import { render, staticRenderFns } from "./index-hoc.vue?vue&type=template&id=35d5fafc&"
import script from "./index-hoc.vue?vue&type=script&lang=js&"
export * from "./index-hoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports